import { render, staticRenderFns } from "./UpdateOnboardingWorkflow.vue?vue&type=template&id=c9b725da&scoped=true&"
import script from "./UpdateOnboardingWorkflow.vue?vue&type=script&lang=js&"
export * from "./UpdateOnboardingWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOnboardingWorkflow.vue?vue&type=style&index=0&id=c9b725da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b725da",
  null
  
)

export default component.exports